import { sagas as requestedServicesSagas } from './modules/requestedServices'
import { sagas as servicesSagas } from './modules/services'

export default [...requestedServicesSagas, ...servicesSagas]
